import aboutChildren from './module/router-children-for-about';
import newChildren from './module/router-children-for-new';
import SoleChildren from './module/router-children-for-Solve';
// import campusemployChildren from './module/router-children-for-campusemploy';
export const routes = [
  {
    path: '/index',
    name: '首页',
    meta: {
      title: '亿车科技_智慧停车 停车场系统 停车场管理系统 车牌识别系统 道闸 智能停车场',
    },
    component: () => import(/* webpackChunkName: "index" */ '@/views/index'),
  },
  {
    path: '/Solve',
    component: () => import(/* webpackChunkName: "Solve" */ '@/views/Solve'),
    redirect: `/Solve/${SoleChildren[0].path}`,
    children: SoleChildren,
  },
  {
    path: '/product',
    component: () =>
      import(/* webpackChunkName: "product" */ '@/views/product'),
    redirect: {
      path: `/product/${newChildren[6].path}`,
      query: { active: 5 },
    },
    children: newChildren,
  },
  {
    path: '/product/znYj',
    name: '智能硬件',
    meta: {
      title: '智能硬件',
    },
    component: () =>
      import(/* webpackChunkName: "znYj" */ '@/views/product/znYj'),
  },
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/about'),
    redirect: `/about/${aboutChildren[0].path}`,
    children: aboutChildren,
  },
  {
    path: '/citypartner',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/citypartner'),
    name: '【蜜蜂停车】全国招募城市合伙人，【星云联盟】正式启动',
    meta: {
      hideTitle: true,
      hideFooter: true,
    },
  },
  {
    path: '/news/detail',
    name: '新闻详情',
    meta: {
      title: '新闻详情',
    },
    component: () =>
      import(/* webpackChunkName: "newsDetail" */ '@/views/news/detail'),
  },
  {
    path: '/casemget/detail',
    name: '',
    meta: {
      title: '',
    },
    component: () =>
      import(
        /* webpackChunkName: "aboutNewsDetail" */ '@/views/casemget/detail'
      ),
  },
  {
    path: '/news',
    name: '新闻中心',
    meta: {
      title: '新闻中心',
    },
    component: () => import(/* webpackChunkName: "news" */ '@/views/news'),
  },
  {
    path: '/parking',
    name: '停车经营',
    meta: {
      title: '停车经营',
    },
    component: () =>
      import(/* webpackChunkName: "parking" */ '@/views/parking'),
  },
  {
    path: '/parkbees',
    name: '蜜蜂停车',
    meta: {
      title: '蜜蜂停车',
    },
    component: () =>
      import(/* webpackChunkName: "parkbees" */ '@/views/parkbees'),
  },
  {
    path: '/connect',
    name: '联系我们',
    meta: {
      title: '联系我们',
    },
    component: () =>
      import(/* webpackChunkName: "connect" */ '@/views/connect'),
  },
  {
    path: '/casemget',
    name: '案例中心',
    meta: {
      title: '案例中心',
    },
    component: () =>
      import(/* webpackChunkName: "connect" */ '@/views/casemget'),
  },
  {
    path: '/',
    redirect: 'index',
  },
  {
    path: '*',
    redirect: 'index',
  },
];
